<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="input-header">
        <BaseInput
          :id="`policy-name-${index}`"
          v-model="localPolicy.policyName"
          :field="{ type: 'input', isHorizontal: true, label: 'Nombre', placeholder: 'Nombre del risk policy' }"
          rules="required"
          size="is-small" />
        <BaseInput
          :id="`policy-description-${index}`"
          v-model="localPolicy.description"
          :field="{ type: 'input', isHorizontal: true, label: 'Descripción', placeholder: 'Descripción de la póliza' }"
          rules="required"
          size="is-small" />
      </div>
      <ValidationProvider v-slot="{ errors }" rules="required">
        <b-taginput
          id="`policy-tags-${index}`"
          v-model="localPolicy.tags"
          :data="tags"
          allow-new
          field="tags"
          icon="label"
          size="is-small"
          placeholder="Agregar un tag"
          :data-cy="`policy-tags-${index}`" />
        <p class="help is-danger">{{ errors[0] }}</p>
      </ValidationProvider>
      <div class="columns fields-policies">
        <div class="column is-6-desktop-only">
          <BaseInput
            :id="'policy-active-' + index"
            v-model="localPolicy.isActive"
            :field="{ type: 'switch', isHorizontal: true, label:'Activo', placeholder: 'Activo', size: 'is-small' }"
            rules="" />

          <BaseInput
            :id="'policy-subsegment-' + index"
            v-model="localPolicy.subSegment"
            :field="{
              type: 'select',
              isHorizontal: true,
              label: 'Subsegmento',
              placeholder: 'Selecciona un subsegmento',
              options: subSegment.map(value => ({ value, label: value }))
            }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-min-ltv-' + index"
            v-model="localPolicy.subSegmentConditions[getSubsegmentIndex(localPolicy.subSegmentConditions, 'offerResponse.loanToValueHome')].minValue"
            :field="{ type: 'number', isHorizontal: true, label: 'LTV min', placeholder: '0.8' }"
            rules="required|max_value:1|min_value:0"
            size="is-small" />

          <BaseInput
            :id="'policy-min-credit-amount-' + index"
            v-model="localPolicy.subSegmentConditions[getSubsegmentIndex(localPolicy.subSegmentConditions, 'offerResponse.creditAmount')].minValue"
            :field="{ type: 'number', isHorizontal: true, label: 'Monto crédito min', placeholder: '100000' }"
            rules="required|numeric"
            size="is-small" />

          <BaseInput
            :id="'policy-purpose-' + index"
            v-model="localPolicy.purpose"
            :field="{
              type: 'select',
              isHorizontal: true,
              label: 'Propósito',
              placeholder: 'Compra de vivienda',
              options: purpose.map(value => ({ value, label: value }))
            }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-maximum-backend-ratio-' + index"
            v-model="localPolicy.maximumBackendRatio"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: 'Back end ratio max', placeholder: '0.36' }"
            rules="required|max_value:1|min_value:0"
            size="is-small" />

          <BaseInput
            :id="'policy-maximum-property-ltv-' + index"
            v-model="localPolicy.maximumPropertyLTV"
            :field="{ type: 'number', prefixPosition:'right', prefix: '%', isHorizontal: true, label: 'LTV propiedad max', placeholder: '0.8' }"
            rules="required|max_value:1|min_value:0" />

          <BaseInput
            :id="'policy-investment-weight-' + index"
            v-model="localPolicy.investmentWeight"
            :field="{ type: 'number', isHorizontal: true, label: 'Investment Weight', placeholder: '0.5' }"
            rules="required|max_value:1|min_value:0"
            size="is-small" />

          <BaseInput
            :id="'policy-property-type-factor-' + index"
            v-model="localPolicy.propertyTypeFactor"
            :field="{ type: 'number', isHorizontal: true, label: 'Factor tipo de propiedad', placeholder: '1.2' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-interest-type-' + index"
            v-model="localPolicy.interestType"
            :field="{
              type: 'select',
              isHorizontal: true,
              label: 'Tipo de interés',
              placeholder: 'Fijo',
              options: interestType.map(value => ({ value, label: value }))
            }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-credit-insurance-financing-' + index"
            v-model="localPolicy.creditInsuranceFinancing"
            :field="{ type: 'number', isHorizontal: true, label: 'Financiamiento seguro de crédito', placeholder: '0.1' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-credit-insurance-number-of-months-' + index"
            v-model="localPolicy.creditInsuranceNumberOfMonths"
            :field="{ type: 'number', isHorizontal: true, label: 'Meses de cobro cuota seguro de crédito', placeholder: '12' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-credit-insurance-rate-' + index"
            v-model="localPolicy.creditInsuranceRate"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: 'Tasa del seguro de crédito', placeholder: '0.01' }"
            rules="required|max_value:1|min_value:0"
            size="is-small" />

          <BaseInput
            :id="'policy-unemployment-insurance-monthly-rate-' + index"
            v-model="localPolicy.unemploymentInsuranceMonthlyRate"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: 'Tasa seguro desempleo', placeholder: '0.002' }"
            rules="required|max_value:1|min_value:0"
            size="is-small" />

          <BaseInput
            :id="'policy-grace-months-interest-method-' + index"
            v-model="localPolicy.graceMonthsInterestMethod"
            :field="{
              type: 'select',
              isHorizontal: true,
              label: 'Método interés gracia',
              placeholder: 'Simple',
              options: graceMonthsInterestMethod.map(value => ({ value, label: value }))
            }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-appraisal-expenses-' + index"
            v-model="localPolicy.appraisalExpenses"
            :field="{ type: 'number', isHorizontal: true, label: 'Gastos Tasación', placeholder: '50000' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-notary-expenses-' + index"
            v-model="localPolicy.notaryExpenses"
            :field="{ type: 'number', isHorizontal: true, label: 'Gastos Notario', placeholder: '20000' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-credit-tax-rate-' + index"
            v-model="localPolicy.creditTaxRate"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: 'Tasa crédito', placeholder: '0.19' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-appraisal-expenses-percentage-' + index"
            v-model="localPolicy.appraisalExpensesPercentage"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: '% Gastos Tasación', placeholder: '0.05' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-notary-expenses-percentage-' + index"
            v-model="localPolicy.notaryExpensesPercentage"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: '% Gastos Notario', placeholder: '0.02' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-credit-tax-rate-percentage-' + index"
            v-model="localPolicy.creditTaxRatePercentage"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: '% Tasa crédito', placeholder: '0.01' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-credit-max-amount-' + index"
            v-model="localPolicy.creditMaxAmount"
            :field="{ type: 'number', isHorizontal: true, label: 'Monto Máx Crédito', placeholder: '1000000' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-target-age-' + index"
            v-model="localPolicy.targetAge"
            :field="{ type: 'number', isHorizontal: true, label: 'Edad Objetivo', placeholder: '30', prefix: '' }"
            rules="required|numeric"
            size="is-small" />

          <BaseInput
            :id="'policy-life-insurance-monthly-rate-ranges-min-age-' + index"
            v-model="localPolicy.lifeInsuranceMonthlyRateRanges[0].minAge"
            :field="{ type: 'number', isHorizontal: true, label: 'Edad Mínima', placeholder: '18' }"
            rules="required|numeric"
            size="is-small" />

          <BaseInput
            :id="'policy-life-insurance-debtor-monthly-rate-ranges-' + index"
            v-model.number="localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0].lifeInsuranceMonthlyRate"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: 'Tasa Seguro Vida', placeholder: '0.001' }"
            rules="required|max_value:1|min_value:0"
            size="is-small" />

          <BaseInput
            :id="'policy-life-insurance-debtor-monthly-rate-ranges-max-age-state-' + index"
            v-model="localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0].maxAge"
            :field="{ type: 'number', isHorizontal: true, label: 'Edad Máxima', prefix:'', placeholder: '65' }"
            rules="required|numeric"
            size="is-small" />

          <BaseInput
            :id="'policy-life-insurance-codebtor-monthly-rate-ranges-min-age-state-' + index"
            v-model="localPolicy.lifeInsuranceCodebtorMonthlyRateRanges[0].minAge"
            :field="{ type: 'number', isHorizontal: true, label: 'Edad Mínima', prefix:'', placeholder: '65' }"
            rules="required|numeric"
            size="is-small" />

          <BaseInput
            :id="'policy-credit-insurance-fee-term-definition-' + index"
            v-model="localPolicy.creditInsuranceFeeTermDefinition"
            :field="{
              type: 'select',
              isHorizontal: true,
              label: 'Definición Plazo Seguro',
              placeholder: 'Anual',
              options: creditInsuranceFeeTermDefinition.map(value => ({ value, label: value }))
            }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-default-number-of-grace-months-' + index"
            v-model="localPolicy.defaultNumberOfGraceMonths"
            :field="{ type: 'number', isHorizontal: true, label: 'Meses Gracia', placeholder: '3' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-version-' + index"
            v-model="localPolicy.version"
            :field="{ type: 'number', isHorizontal: true, label: 'Versión', placeholder: '1.0' }"
            rules="required"
            size="is-small" />
        </div>
        <div class="column is-6-desktop-only">
          <BaseInput
            :id="'policy-segment-' + index"
            v-model="localPolicy.segment"
            :field="{
              type: 'select',
              isHorizontal: true,
              label: 'Segmento',
              placeholder: 'SUBSIDY',
              options: segment.map(value => ({ value, label: value }))
            }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-subsegment-description-' + index"
            v-model="localPolicy.subSegmentDescription"
            :field="{ type: 'input', isHorizontal: true, label: 'Descripción subsegmento', placeholder: 'Política de riesgo para créditos hipotecarios' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-max-ltv-' + index"
            v-model="localPolicy.subSegmentConditions[getSubsegmentIndex(localPolicy.subSegmentConditions, 'offerResponse.loanToValueHome')].maxValue"
            :field="{ type: 'number', isHorizontal: true, label: 'LTV max', placeholder: '80' }"
            rules="required|max_value:1|min_value:0"
            size="is-small" />

          <BaseInput
            :id="'policy-max-credit-amount-' + index"
            v-model="localPolicy.subSegmentConditions[getSubsegmentIndex(localPolicy.subSegmentConditions, 'offerResponse.creditAmount')].maxValue"
            :field="{ type: 'number', isHorizontal: true, label: 'Monto crédito max', placeholder: '1000000' }"
            rules="required|numeric"
            size="is-small" />

          <BaseInput
            :id="'policy-icon-' + index"
            v-model="localPolicy.icon"
            :field="{ type: 'input', isHorizontal: true, label: 'Icono', placeholder: 'home' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-maximum-frontend-ratio-' + index"
            v-model="localPolicy.maximumFrontendRatio"
            :field="{ type: 'number', isHorizontal: true, label: 'Ratio max', placeholder: '0.3' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-maximum-credit-ltv-' + index"
            v-model="localPolicy.maximumCreditLTV"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: 'Crédito Max LTV', placeholder: '0.8' }"
            rules="required|min_value:0|max_value:1"
            size="is-small" />

          <BaseInput
            :id="'policy-amortization-method-' + index"
            v-model="localPolicy.amortizationMethod"
            :field="{
              type: 'select',
              isHorizontal: true,
              label: 'Método amortización',
              placeholder: 'Francés',
              options: amortizationMethod.map(value => ({ value, label: value }))
            }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-tax-rate-' + index"
            v-model="localPolicy.taxRate"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: 'Tasa impuesto', placeholder: '0.19' }"
            rules="required|min_value:0|max_value:1"
            size="is-small" />

          <BaseInput
            :id="'policy-annual-interest-rate-' + index"
            v-model="localPolicy.annualInterestRate"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: 'Tasa interés anual', placeholder: '0.05' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-credit-insurance-percentage-financed-' + index"
            v-model="localPolicy.creditInsurancePercentageFinanced"
            :field="{ type: 'number', isHorizontal: true, label: '% seguro crédito financiado', placeholder: '0.1' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-operational-expenses-number-of-months-' + index"
            v-model="localPolicy.operationalExpensesNumberOfMonths"
            :field="{ type: 'number', isHorizontal: true, label: 'Meses gastos operacionales', placeholder: '12' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-property-insurance-monthly-rate-' + index"
            v-model="localPolicy.propertyInsuranceMonthlyRate"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: 'Tasa seguro propiedad', placeholder: '0.002' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-subsidy-rate-' + index"
            v-model="localPolicy.subsidyRate"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: 'Tasa subsidio', placeholder: '0.05' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-deed-expenses-' + index"
            v-model="localPolicy.deedExpenses"
            :field="{ type: 'number', isHorizontal: true, label: 'Gastos escritura', placeholder: '50000' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-title-study-expenses-' + index"
            v-model="localPolicy.titleStudyExpenses"
            :field="{ type: 'number', isHorizontal: true, label: 'Gastos estudio título', placeholder: '20000' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-real-estate-expenses-rate-' + index"
            v-model="localPolicy.realEstateExpensesRate"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: '% Gastos inmobiliarios', placeholder: '0.01' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-deed-expenses-percentage-' + index"
            v-model="localPolicy.deedExpensesPercentage"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: '% Gastos escritura', placeholder: '0.05' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-title-study-expenses-percentage-' + index"
            v-model="localPolicy.titleStudyExpensesPercentage"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: '% Gastos estudio título', placeholder: '0.02' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-real-estate-expenses-percentage-' + index"
            v-model="localPolicy.realEstateExpensesPercentage"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal: true, label: '% Gastos inmobiliarios', placeholder: '0.01' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-operational-expenses-interest-' + index"
            v-model="localPolicy.operationalExpensesInterest"
            :field="{
              type: 'select',
              isHorizontal: true,
              label: 'Interés gastos operacionales',
              placeholder: '.',
              options: operationalExpensesInterest.map(value => ({ value, label: value }))
            }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-credit-min-amount-' + index"
            v-model="localPolicy.creditMinAmount"
            :field="{ type: 'number', isHorizontal: true, label: 'Monto Mín Crédito', placeholder: '100000' }"
            rules="required"
            size="is-small" />

          <!-- AQUIIII -->

          <BaseInput
            :id="'policy-life-insurance-monthly-rate-' + index"
            v-model="localPolicy.lifeInsuranceMonthlyRateRanges[0].lifeInsuranceMonthlyRate"
            :field="{ type: 'number', prefixPosition:'right', prefix:'%', isHorizontal:true, label: 'lifeInsuranceMonthlyRate', placeholder: '0.001' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-life-insurance-monthly-rate-max-age-' + index"
            v-model="localPolicy.lifeInsuranceMonthlyRateRanges[0].maxAge"
            :field="{ type: 'number', isHorizontal: true, label: 'maxAge', placeholder: '0.001' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-min-age-codebtor-' + index"
            v-model="localPolicy.lifeInsuranceDebtorMonthlyRateRanges[0].minAge"
            :field="{ type: 'number', isHorizontal: true, label: 'lifeInsuranceMonthlyRate MinAge Debtor', placeholder: '0.001' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-life-insurance-monthly-rate-codebtor-' + index"
            v-model="localPolicy.lifeInsuranceCodebtorMonthlyRateRanges[0].lifeInsuranceMonthlyRate"
            :field="{ type: 'number', isHorizontal: true, label: 'lifeInsuranceMonthlyRate Codebtor', placeholder: '65' }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-max-age-codebtor-' + index"
            v-model="localPolicy.lifeInsuranceCodebtorMonthlyRateRanges[0].maxAge"
            :field="{ type: 'number', isHorizontal: true, label: 'trumaxAgee codebtor', placeholder: '65' }"
            rules="required"
            size="is-small" />

          <!-- HASTA AQUIII -->

          <BaseInput
            :id="'policy-is-credit-insurance-accelerated-' + index"
            v-model="localPolicy.isCreditInsuranceAccelerated"
            :field="{ type: 'switch', isHorizontal: true, label:'¿Es acelerado el seguro de crédito?', placeholder: 'Activo', size: 'is-small' }"
            rules="" />

          <BaseInput
            :id="'policy-life-insurance-type-of-premium-' + index"
            v-model="localPolicy.lifeInsuranceTypeOfPremium"
            :field="{
              type: 'select',
              isHorizontal: true,
              label: 'Tipo prima seguro',
              placeholder: 'constante',
              options: lifeInsuranceTypeOfPremium.map(value => ({ value, label: value }))
            }"
            rules="required"
            size="is-small" />

          <BaseInput
            :id="'policy-credit-length-by-default-' + index"
            v-model="localPolicy.creditLenghtByDefault"
            :field="{ type: 'number', isHorizontal: true, label: 'Longitud crédito', placeholder: '120' }"
            rules="required"
            size="is-small" />
        </div>
      </div>
      <div class="buttons">
        <b-button
          type="is-text"
          @click="cancelPolicy">
          Cancelar
        </b-button>
        <b-button
          type="is-danger"
          data-cy="policy-change"
          @click="emitPolicyChange">
          Aplicar
        </b-button>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import BaseInput from '@/ui/components/input/BaseInput.vue';
import {
  amortizationMethod,
  purpose,
  segment,
  subSegment,
  interestType,
  graceMonthsInterestMethod,
  operationalExpensesInterest,
  lifeInsuranceTypeOfPremium,
  creditInsuranceFeeTermDefinition
} from '@/domain/constants/default-risk-policy-data';

export default {
  name: 'RiskPolicyDetail',
  components: {
    BaseInput
  },
  props: {
    policy: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    tags: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      segment,
      subSegment,
      purpose,
      amortizationMethod,
      interestType,
      graceMonthsInterestMethod,
      operationalExpensesInterest,
      lifeInsuranceTypeOfPremium,
      creditInsuranceFeeTermDefinition,
      localPolicy: {
        ...this.policy
      }
    };
  },
  methods: {
    cancelPolicy() {
      this.$emit('cancel', this.index);
    },
    async emitPolicyChange() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.$emit('change:policy', { policy: this.localPolicy, index: this.index });
    },
    getSubsegmentIndex(subSegmentConditions, subSegmentCondition) {
      return subSegmentConditions.findIndex(condition => condition.path === subSegmentCondition);
    }
  }
};
</script>
<style scoped>

.fields-policies{
  margin-top: 1rem;
}
.policy-item .input-header{
  width: 60%;
}

</style>
